/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum TerminalTypeApiModel {
  Register = 'register',

  Steward = 'steward',

  Validator = 'validator',

  PrepaidServices = 'prepaid-services',

  RoadTankerDriver = 'road-tanker-driver',

  Kiosk = 'kiosk',

  KioskAndRegister = 'kiosk-and-register'
}
